// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig:{
    apiKey: "AIzaSyCWVNyGNF85TmKvX5ax2kbVMnMaJmpn0t8",
    authDomain: "studies-151020.firebaseapp.com",
    databaseURL: "https://studies-151020.firebaseio.com",
    projectId: "studies-151020",
    storageBucket: "studies-151020.appspot.com",
    messagingSenderId: "682619463698",
    appId: "1:682619463698:web:065da220b9e7e75dd810cb"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
